import { Stack, Typography } from "@mui/material";
import { Link, Outlet, useLocation } from "react-router-dom";
import ProtectedRoute from "../../routing/ProtectedRoute";
import { startCase } from "lodash";
import { useAuth } from "../../../context/AuthContext";
import { ReactNode, useMemo } from "react";
import { BreadcrumbsContainer, BreadcrumbsContextProvider } from "@components/custom-components/breadcrumbs/BreadcrumbsContext";
import { ParentTeacherContextProvider } from "./ParentTeacherContext";
import ErrorBoundary from "../../common/ErrorBoundary";

const ParentTeacherLayout = ({ children }: { children?: ReactNode }) => {
  const { baseRole: role } = useAuth();
  const { pathname } = useLocation();
  const isIDPath = (path: string) => {
    const guidRegex = /^\{?[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-5][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}\}?$/;
    const guid = guidRegex.test(path);
    const number = !isNaN(Number(path));
    return !guid && !number;
  }
  const locations = useMemo(() => {
    return pathname?.split("/").filter(isIDPath);
  }, [pathname]);

  return (
    <ProtectedRoute>
      <ParentTeacherContextProvider>
        <BreadcrumbsContextProvider>
          <Stack p={3}>

            <BreadcrumbsContainer>
              {!locations?.slice(1)?.length && (
                <Link color="inherit" to="/">
                  <Typography variant="breadcrumbs">
                    {`${startCase(role || "")} Dashboard`}
                  </Typography>
                </Link>
              )}
              {locations?.slice(1).map((l, index) => (
                <Link
                  key={index}
                  color="inherit"
                  to={`/${locations?.join("/")}`}
                >
                  <Typography variant="breadcrumbs">
                    {startCase(l)}
                  </Typography>
                </Link>
              ))}
            </BreadcrumbsContainer>

            <ErrorBoundary resetKey={pathname}>
              {children}
              <Outlet />
            </ErrorBoundary>
          </Stack>
        </BreadcrumbsContextProvider>
      </ParentTeacherContextProvider>
    </ProtectedRoute>
  );
};

export default ParentTeacherLayout;
